import { StyledIcon } from "@styled-icons/styled-icon";
import {
  D12Background,
  D12BackgroundBlank,
  D20Background,
  D20BackgroundBlank,
  D6Background,
  D6BackgroundBlank,
  D8Background,
  D8BackgroundBlank,
  D9Background,
  D9BackgroundBlank,
  D10Background,
  D10BackgroundBlank,
  Dice1Icon,
  Dice2Icon,
  Dice3Icon,
  Dice4Icon,
  Dice5Icon,
  Dice6Icon,
} from "assets/icons";
import { ComponentType, ReactNode } from "react";
import styled from "styled-components";

interface DiceConfig {
  background?: ComponentType<any>;
  faces: ReactNode[];
  settings: { icon: StyledIcon; copy: string };
}

const NumberDiceFace = styled.p<{ fontSize?: number }>`
  font-size: ${(props) => props.fontSize || 15}cqw;
  font-weight: 600;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const D8DiceFace = styled.p`
  font-size: 9cqw;
  font-weight: 600;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const diceConfig: { [id: string]: DiceConfig } = {
  standard: {
    background: undefined,
    faces: [
      <Dice1Icon />,
      <Dice2Icon />,
      <Dice3Icon />,
      <Dice4Icon />,
      <Dice5Icon />,
      <Dice6Icon />,
    ],
    settings: {
      icon: Dice6Icon,
      copy: "D6 Dots",
    },
  },
  standardNumerals: {
    background: D6BackgroundBlank,
    faces: [
      <NumberDiceFace>1</NumberDiceFace>,
      <NumberDiceFace>2</NumberDiceFace>,
      <NumberDiceFace>3</NumberDiceFace>,
      <NumberDiceFace>4</NumberDiceFace>,
      <NumberDiceFace>5</NumberDiceFace>,
      <NumberDiceFace>6</NumberDiceFace>,
    ],
    settings: {
      icon: D6Background,
      copy: "D6 Numerals",
    },
  },
  D8Numerals: {
    background: D8BackgroundBlank,
    faces: [
      <D8DiceFace>1</D8DiceFace>,
      <D8DiceFace>2</D8DiceFace>,
      <D8DiceFace>3</D8DiceFace>,
      <D8DiceFace>4</D8DiceFace>,
      <D8DiceFace>5</D8DiceFace>,
      <D8DiceFace>6</D8DiceFace>,
      <D8DiceFace>7</D8DiceFace>,
      <D8DiceFace>8</D8DiceFace>,
    ],
    settings: {
      icon: D8Background,
      copy: "D8 Numerals",
    },
  },
  D9Numerals: {
    background: D9BackgroundBlank,
    faces: [
      <D8DiceFace>1</D8DiceFace>,
      <D8DiceFace>2</D8DiceFace>,
      <D8DiceFace>3</D8DiceFace>,
      <D8DiceFace>4</D8DiceFace>,
      <D8DiceFace>5</D8DiceFace>,
      <D8DiceFace>6</D8DiceFace>,
      <D8DiceFace>7</D8DiceFace>,
      <D8DiceFace>8</D8DiceFace>,
      <D8DiceFace>9</D8DiceFace>,
    ],
    settings: {
      icon: D9Background,
      copy: "D9 Numerals",
    },
  },
  D10Numerals: {
    background: D10BackgroundBlank,
    faces: [
      <D8DiceFace>1</D8DiceFace>,
      <D8DiceFace>2</D8DiceFace>,
      <D8DiceFace>3</D8DiceFace>,
      <D8DiceFace>4</D8DiceFace>,
      <D8DiceFace>5</D8DiceFace>,
      <D8DiceFace>6</D8DiceFace>,
      <D8DiceFace>7</D8DiceFace>,
      <D8DiceFace>8</D8DiceFace>,
      <D8DiceFace>9</D8DiceFace>,
      <D8DiceFace>10</D8DiceFace>,
    ],
    settings: {
      icon: D10Background,
      copy: "D10 Numerals",
    },
  },
  D12Numerals: {
    background: D12BackgroundBlank,
    faces: [
      <NumberDiceFace fontSize={8}>1</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>2</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>3</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>4</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>5</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>6</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>7</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>8</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>9</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>10</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>11</NumberDiceFace>,
      <NumberDiceFace fontSize={8}>12</NumberDiceFace>,
    ],
    settings: {
      icon: D12Background,
      copy: "D12 Numerals",
    },
  },
  D20Numerals: {
    background: D20BackgroundBlank,
    faces: [
      <NumberDiceFace fontSize={6}>1</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>2</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>3</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>4</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>5</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>6</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>7</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>8</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>9</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>10</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>11</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>12</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>13</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>14</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>15</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>16</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>17</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>18</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>19</NumberDiceFace>,
      <NumberDiceFace fontSize={6}>20</NumberDiceFace>,
    ],
    settings: {
      icon: D20Background,
      copy: "D20 Numerals",
    },
  },
};
